// extracted by mini-css-extract-plugin
export var legendIndicator = "_er-1";
export var legendRight = "_er-0";